import { categoriesNlToEn } from "@config/urls"
import { SingleItemResponse } from "@lib/kontent/fetchContent"
import { getCollectionDetailPage } from "@lib/kontent/getCollectionDetailPage"
import { CollectionDetailPage as CollectionDetailModel } from "@lib/kontent/models/CollectionDetailPage"
import { PageProps } from "@lib/types"
import CollectionDetail from "@screens/collection/detail"
import { ErrorPage } from "@screens/error"
import { NextPage } from "next"

type Props = PageProps<SingleItemResponse<CollectionDetailModel>> & {
  uid: string
}

const CollectionDetailPage: NextPage<Props> = ({ data, uid, statusCode }) => {
  if (statusCode) {
    return <ErrorPage statusCode={statusCode} />
  }
  if (!data) {
    return <ErrorPage statusCode={500} />
  }

  return (
    <CollectionDetail
      collection={data.item}
      modularContent={data.modular_content}
      uid={uid}
    />
  )
}

CollectionDetailPage.getInitialProps = async ({ lang, query }) => {
  const uid =
    lang === "nl"
      ? categoriesNlToEn[query["uid"] as string]
      : (query.uid as string)
  try {
    const content = await getCollectionDetailPage<CollectionDetailModel>({
      urlSlug: uid,
      language: lang,
    })
    if (!content) {
      return { statusCode: 404, uid }
    }
    return {
      data: content,
      uid,
    }
  } catch (error) {
    console.error(error)
    return { statusCode: 500, uid }
  }
}

export default CollectionDetailPage
